import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import {
  CriteriaRequest,
  PagedList,
} from '@daas-consulting/core-cross-interfaces';
import * as utils from '@daas-consulting/core-frontend-utils';
import {
  Configuration,
  ConfigurationId,
} from '@daas-consulting/production/shared/cross/configuration';
import { AuditService } from '@daas-consulting/security/audit/frontend/data_contracts';
import { AuditModel } from '@daas-consulting/security/audit/frontend/models';
import { Observable, map } from 'rxjs';

@Injectable()
export class HttpAuditService implements AuditService {
  readonly #baseUrl: string;
  readonly #http!: HttpClient;

  constructor(
    http: HttpClient,
    @Inject(ConfigurationId) configuration: Configuration
  ) {
    this.#http = http;
    this.#baseUrl = `${configuration.baseUrl}/audit`;
  }

  search$(criteria: CriteriaRequest): Observable<PagedList<AuditModel>> {
    throw new Error('Method not implemented.');
  }

  get$(entity: string, entityId: string): Observable<AuditModel | null> {
    const url = `${this.#baseUrl}/${entity}/${entityId}`;
    return this.#http.get<AuditModel | null>(url).pipe(
      utils.rxjs.retryWhenNot401(3),
      map((x) => ({ ...x, entityId: entityId, entity: entity }))
    );
  }

  history$(entity: string, entityId: string): Observable<AuditModel[]> {
    const url = `${this.#baseUrl}/${entity}/${entityId}/history`;
    return this.#http.get<AuditModel[]>(url).pipe(
      utils.rxjs.retryWhenNot401(3),
      map((x) => x.map((y) => ({ ...y, entityId: entityId, entity: entity })))
    );
  }

  detail$(
    entity: string,
    entityId: string,
    seq: number
  ): Observable<AuditModel | null> {
    const url = `${this.#baseUrl}/${entity}/${entityId}/detail/${seq}`;
    return this.#http.get<AuditModel | null>(url).pipe(
      utils.rxjs.retryWhenNot401(3),
      map((x) => (x ? { ...x, entityId: entityId, entity: entity } : null))
    );
  }
}
